import React, { Component } from 'react';
import { FormattedMessage, defineMessages ,   injectIntl } from 'react-intl';

import GuideBoxUI from './GuideBoxUI';

const messages=defineMessages({
  dimensions:{
    id:'Guide.sizeTable.dimensions',
    defaultMessage:'Dimensions'
  },
  margins:{
    id:'Guide.sizeTable.margins',
    defaultMessage:'Margins'
  },
  marginsData:{
    id:'Guide.sizeTable.margins.data',
    defaultMessage:'20px on all sides'
  },
  size:{
    id:'Guide.sizeTable.size',
    defaultMessage:'Size'
  },
  sizeData:{
    id:'Guide.sizeTable.size.data',
    defaultMessage:'Not more than 500KB'
  }
});

class SizeAndMargins extends Component{

  render(){
    const {formatMessage}=this.props.intl;
    const sizeColumn = [{
        title: formatMessage(messages.dimensions),
        width: 227,
        dataIndex:'dimensions'
      },{
        title: formatMessage(messages.size),
        width: 227,
        dataIndex:'size'
    }];
    const sizeData =  [{
      key: '1',
      dimensions: '618 x 618 (px)',
      margins: formatMessage(messages.marginsData),
      size: formatMessage(messages.sizeData)
    }];

    return(
      <div className="size-and-margins">
        <GuideBoxUI
          imgIcon={require('../img/guide/format_icon_size.svg')}
          title={{
            id: 'Guide.size&margin',
            defaultMessage :'Size and Margins'
          }}
          table={{
            column : sizeColumn,
            data: sizeData,
            className: 'size-table',
          }}
          description={{
            id :'Guide.size&margin.description',
            defaultMessage:'- Make sure that the size of the sticker is 618 x 618 px.<br/><br/>- There should be a clear margin of 20 px on all sides. <br/><br/>- The image file size should not exceed 500KB.'
          }}
        />
        <p>
          <FormattedMessage
            id={'Guide.size&margin.example'}
            defaultMessage={'Size and Margins example :'}
          />
        </p>
        <img className="example" src={require('../img/guide/size_ex_618.png').default} alt=""/>
      </div>
    )
  }

}
  
SizeAndMargins=injectIntl(SizeAndMargins);

export default SizeAndMargins;
